import { Dashboard, DashboardType, Organization } from 'src/types';

export const getGarmDashboards = (organization: Organization): Dashboard[] => {
  return organization.dashboards.filter(
    (dashboard) =>
      dashboard.type === DashboardType.MAIN ||
      dashboard.type === DashboardType.GARM
  );
};
